import { RouteFactory } from "@app/routePaths";
import AccordionV2 from "@components/Accordion/AccordionV2";
import Column from "@components/Grid/Column";

import SIAAccordionHeader from "./SIAAccordionHeader";

/**
 * component to render in Assesment tab at How to Nominate page
 */
const AssesmentSection = (): React.ReactElement => {
  return (
    <Column rootClassName="px-0">
      <AccordionV2
        testId="assesment-individual-category-accordion"
        className="rounded-tl-lg rounded-tr-lg border border-gray-175 bg-gray-150 py-4"
        headerChildren={<SIAAccordionHeader title="Individual Category" />}
        arrowClassName="h-auto w-auto -rotate-90 mr-6"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4">
          <p>The following framework will be used to measure the impact:</p>

          <p>
            <strong>Core Attributes</strong>
          </p>

          <ul className="list-outside list-disc pl-8">
            <li>
              <strong>Significance:</strong>

              <ul className="list-outside list-disc pb-6 pl-8">
                <li>
                  The individual should demonstrate the significance of the
                  actual environmental and/or social outcome resulting from the
                  implementation of the projects/initiatives/programmes he/she
                  led.
                </li>
                <li>
                  Significance in fulfilling the needs should be emphasised and
                  clearly articulated. The individual is encouraged to share
                  descriptions of the significance to meeting the
                  organisational, community, national, regional and/or
                  international goals and needs.
                </li>
                <li>
                  Indirect impact that results in improving the enterprise’s
                  profitability need not necessarily be included. However,
                  please demonstrate other indirect outcomes as well if there
                  were any.
                </li>
              </ul>
            </li>

            <li>
              <strong>Leadership:</strong>

              <ul className="list-outside list-disc pb-6 pl-8">
                <li>
                  The individual must demonstrate his/her leadership in
                  effectively implementing the projects/initiatives/programmes.
                </li>
                <li>
                  Individuals who implemented pioneering
                  projects/initiatives/programmes and has influenced a large
                  scale of stakeholders will be awarded bonus point.
                </li>
              </ul>
            </li>
          </ul>

          <p>
            <strong>Essential Attributes</strong>
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              <strong>Advocacy:</strong> The individual should demonstrate how
              he/she advocates in creating changes as well as how he/she engaged
              and motivated internal and external stakeholders. For example, how
              he/she influences business strategies/decisions, influences the
              public policy, influences the employees’ behaviours, influences
              policymakers etc.
            </li>
            <li>
              <strong>Scope:</strong> The individual must demonstrate how the
              projects/initiatives/programmes he/she led positively affect the
              local community in Singapore. The individual who extends his/her
              impact beyond Singapore to reach larger scope will be awarded
              bonus point based on how large the impact is.
            </li>
            <li>
              <strong>Duration:</strong> Duration of the impact refers to the
              period that relevant stakeholders experienced the outcome. This
              award values both short-and long-term impact.
            </li>
            <li>
              <strong>Depth:</strong> Depth of the impact refers to the degree
              of change in the outcome level experienced by relevant
              stakeholders. Examples could be the degree of improving the lives
              of local communities, the degree of improving energy efficiency.
            </li>
          </ul>

          <p>
            <strong>Pre-requisite: Good Governance</strong>
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              <strong>Governing Leadership:</strong> The applicant should show
              his/her uphold strong mission and vision of his/her enterprise,
              ensuring leaders of every level are committed to fairness,
              transparency, diversity, equity, and inclusion.
            </li>
            <li>
              <strong>Engagement of Stakeholders:</strong> The individual should
              demonstrate his/her practices regarding stakeholder engagement.
              This includes but not limited to practices to enhance
              participation of internal stakeholders and actions to engage
              external stakeholders.
            </li>
            <li>
              <strong>Compliance:</strong> The individual should demonstrate
              that he/she does not have any outstanding charges.
            </li>
          </ul>

          <p>
            <strong>Evaluation</strong>
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              The individual will be evaluated based on the social and/or
              environmental outcome attributing to his/her efforts instead of
              the size or the impact of his/her enterprise.
            </li>
            <li>
              This award will honour individual who has showed singular
              excellence in environmental or social aspects as well as
              individual who has shown excellence in both aspects.
            </li>
          </ul>

          <p>
            <a
              className="text-blue-175 hover:text-gray-750"
              href={RouteFactory.siaAwardsPage}
            >
              <u>
                <strong>Click here</strong>
              </u>
            </a>{" "}
            for the assessment criteria
          </p>
        </div>
      </AccordionV2>

      <AccordionV2
        testId="assesment-enterprise-category-accordion"
        className="rounded-bl-lg rounded-br-lg border border-t-0 border-gray-175 bg-gray-150 py-4"
        headerChildren={<SIAAccordionHeader title="Enterprise Category" />}
        arrowClassName="h-auto w-auto -rotate-90 mr-6"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4">
          <p>The following framework will be used to measure the impact:</p>

          <p>
            <strong>Core Attributes</strong>
          </p>

          <ul className="list-outside list-disc pl-8">
            <li>
              <strong>Significance:</strong>

              <ul className="list-outside list-disc pb-6 pl-8">
                <li>
                  The enterprise should demonstrate the significance of the
                  actual environmental and/or social resulting from the
                  implementation of the projects/initiatives/programmes.
                </li>
                <li>
                  Significance in fulfilling the needs should be emphasised and
                  clearly articulated. The enterprise is encouraged to share
                  descriptions of the significance to meeting the community,
                  national, regional and/or international goals and needs.
                </li>
              </ul>
            </li>

            <li>
              <strong>Leadership:</strong>

              <ul className="list-outside list-disc pb-6 pl-8">
                <li>
                  The enterprise must demonstrate its leadership in carrying out
                  the projects/initiatives/programmes.
                </li>
                <li>
                  The enterprise which carried out pioneering
                  projects/initiatives/programmes and have influenced other
                  entities such as other enterprises, medias, academic
                  institutions will be awarded bonus point.
                </li>
              </ul>
            </li>
          </ul>

          <p>
            <strong>Essential Attributes</strong>
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              <strong>Scale:</strong> The enterprise should demonstrate the
              scale of the impact, including but not limited to the groups of
              stakeholders affected, the scale of people reached, the scale of
              people experiencing the outcome etc.
            </li>
            <li>
              <strong>Scope:</strong> The enterprise should demonstrate its
              contribution to Singapore&apos;ss national priorities/national
              strategies/national development plans. Enterprise which extends
              its impact beyond Singapore to reach larger scope will be awarded
              bonus point based on how large the impact is.
            </li>
            <li>
              <strong>Duration:</strong> Duration of the impact refers to the
              period that relevant stakeholders experienced the outcome. This
              award values both short- and long-term impact.
            </li>
            <li>
              <strong>Depth:</strong> Depth of the impact refers to the degree
              of change in the outcome level experienced by relevant
              stakeholders. Examples could be the degree of improving the lives
              of local communities, the degree of improving energy efficiency,
              etc.
            </li>
          </ul>

          <p>
            <strong>Bonus Points</strong>
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              <strong>Synergy:</strong> The enterprise which promotes
              sustainability while collaborating with other entities and actors
              will be awarded bonus point. Examples including but not limited to
              engaging suppliers to promote a green supply chain, engaging
              consumers to promote a green lifestyle.
            </li>
            <li>
              <strong>Innovation:</strong> The enterprise would be awarded bonus
              point if the creativeness and originality of the
              projects/initiatives/ programmes are proven.
            </li>
          </ul>

          <p>
            <strong>Pre-requisite</strong>
          </p>

          <ul className="list-outside list-disc pl-8">
            <li>
              <strong>Environmental Practices</strong>

              <ul className="list-outside list-disc pb-6 pl-8">
                <li>
                  <strong>Targets:</strong> Enterprise should demonstrate its
                  targets/visions/statements regarding environmental protection.
                  Environmental protection includes but not limited to waste
                  management, energy conservation, climate actions etc.
                </li>
                <li>
                  <strong>Strategies:</strong> Enterprise should illustrate the
                  strategies and practices to achieve the above-mentioned
                  targets/visions/statements.
                </li>
              </ul>
            </li>

            <li>
              <strong>Social Practices</strong>

              <ul className="list-outside list-disc pb-6 pl-8">
                <li>
                  <strong>Engagement of Employees:</strong> Enterprise should
                  demonstrate how it engages its employees. The engagement
                  methods include but are not limited to open dialogue, employee
                  surveys etc.
                </li>
                <li>
                  <strong>Wellbeing of Employees:</strong> Enterprise should
                  demonstrate practices carried out to improve the wellbeing of
                  employees. These practices include but are not limited to
                  training and education, occupational health and safety
                  practices, diversity, and inclusion practices etc.
                </li>
              </ul>
            </li>

            <li>
              <strong>Good Governance Practices</strong>

              <ul className="list-outside list-disc pb-6 pl-8">
                <li>
                  <strong>Governing Leadership:</strong> The enterprise should
                  show its commitment to values that are conducive to the
                  success of the enterprise, employees, and stakeholders at
                  large which includes but not limited to fairness,
                  transparency, diversity, equity, and inclusion.
                </li>
                <li>
                  <strong>Engagement of Stakeholders:</strong> The enterprise
                  should demonstrate practices regarding stakeholder engagement.
                  This includes but not limited to policies/regulations that
                  ensure the rights of stakeholders, avenues for stakeholders to
                  participate etc.
                </li>
                <li>
                  <strong>Transparency and Disclosure:</strong> Enterprises
                  should demonstrate the contents of disclosure and their medium
                  for communication. Contents of disclosure includes but not
                  limited to the enterprise’s financial disclosure, ownership
                  structure and voting rights, remuneration policy, related
                  party transactions, risk factors, issues regarding
                  stakeholders, governance structure and policies.
                </li>
                <li>
                  <strong>Financial Viability:</strong> The enterprise should
                  demonstrate the capability of the entity to have been
                  financially sustainable. This includes but not limited to
                  ensuring the optimum use of resources to generate profit,
                  financial security and ability to obtain proper funding when
                  required.
                </li>
              </ul>
            </li>
          </ul>

          <p>
            <strong>Evaluation</strong>
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              The enterprise will be evaluated based on the social and/or
              environmental outcome attributing to its efforts.
            </li>
            <li>
              This award honours enterprise that has showed singular excellence
              in environmental or social aspects as well as enterprise that has
              showed excellence in both aspects.
            </li>
          </ul>

          <p>
            <a
              className="text-blue-175 hover:text-gray-750"
              href={RouteFactory.siaAwardsPage}
            >
              <u>
                <strong>Click here</strong>
              </u>
            </a>{" "}
            for the assessment criteria
          </p>
        </div>
      </AccordionV2>
    </Column>
  );
};

export default AssesmentSection;
